import { render, staticRenderFns } from "./TherapyData.vue?vue&type=template&id=18dc57c8&"
import script from "./TherapyData.vue?vue&type=script&lang=js&"
export * from "./TherapyData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports